import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FormStepperComponent } from './form-stepper/form-stepper.component';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatDialogModule } from '@angular/material/dialog';
import { LoadingModule } from '@gwc/loading/loading.module';
import { FormStepperSelectInstitutionComponent } from './steps/select-institution/select-institution.component';
import { CasualHireFormRoutingModule } from './casual-hire-form-routing.module';
import { HireFormNavigationButtonComponent } from './navigation-button/navigation-button.component';
import { HireFormOrderSummaryComponent } from './order-summary/order-summary.component';
import { CasualHireFormComponent } from './casual-hire-form.component';
import { ProcessOrderDialogComponent } from './dialog/process-order-dialog/process-order-dialog.component';
import { HireFormSelectQualificationsComponent } from './steps/select-qualifications/select-qualifications.component';
import { HireFormSelectCollectionDateComponent } from './steps/select-collection-date/select-collection-date.component';
import { HireFormSelectRegliaCopmonent } from './steps/select-regalia/select-regalia.component';
import { HireFormDetailsPaymentComponent } from './steps/details-payment/details-payment.component';
import { HireFormOrderConfirmationComponent } from './steps/order-confirmation/order-confirmation.component';
import { MultiGownSelectDialogComponent } from './dialog/multi-gown-select-dialog/multi-gown-select-dialog.component';
import { TermsConditionsDialogComponent } from './dialog/terms-conditions/terms-conditions-dialog/terms-conditions-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CustomPipesModule } from '@f3/pipes/custom-pipes.module';
import { HireFormIntroComponent } from './intro/intro.component';
import { ConfirmationDialogComponent } from './dialog/confirmation-dialog/confirmation-dialog.component';

@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        CasualHireFormRoutingModule,
        LoadingModule,
        CustomPipesModule,
        FontAwesomeModule,
        MatChipsModule,
        MatCardModule,
        MatIconModule,
        MatDatepickerModule,
        MatButtonModule,
        MatFormFieldModule,
        MatExpansionModule,
        MatInputModule,
        MatSelectModule,
        MatDialogModule,
        CasualHireFormComponent,
        FormStepperComponent,
        HireFormNavigationButtonComponent,
        HireFormOrderSummaryComponent,
        ProcessOrderDialogComponent,
        MultiGownSelectDialogComponent,
        TermsConditionsDialogComponent,
        HireFormIntroComponent,
        FormStepperSelectInstitutionComponent,
        HireFormSelectQualificationsComponent,
        HireFormSelectCollectionDateComponent,
        HireFormSelectRegliaCopmonent,
        HireFormDetailsPaymentComponent,
        HireFormOrderConfirmationComponent,
        ConfirmationDialogComponent
    ],
    exports: [
    // SelectGraduationComponent
    ]
})
export class CasualHireFormModule { }
